"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FreeTrialUserEligibility = void 0;
var FreeTrialUserEligibility;
(function (FreeTrialUserEligibility) {
    FreeTrialUserEligibility["ELIGIBLE"] = "ELIGIBLE";
    FreeTrialUserEligibility["INELIGIBLE"] = "INELIGIBLE";
    FreeTrialUserEligibility["UNKNOWN"] = "UNKNOWN";
})(FreeTrialUserEligibility = exports.FreeTrialUserEligibility || (exports.FreeTrialUserEligibility = {}));
